<app-sales-simulator-kredicash (nextStepEvent)="onNextStep()" *ngIf="categoryCode==Category.kredicash" />
